import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import '@walmart-web/livingdesign-components/index.esm.css';
import { DataTableHeader } from '@walmart-web/livingdesign-components';
import '../Alert/Alert.js';
import '../Button/Button.js';
import '../Button/ButtonGroup.js';
import '../Radio/Radio.js';
import '../Tag/Tag.js';
import '../Checkbox/Checkbox.js';
import '../Chip/Chip.js';
import classNames from 'classnames';
import '../IconButton/IconButton.js';
import '@livingdesign/icons';
import '@livingdesign/tokens/dist/js/light/regular/components/Form';
import '../TextField/TextField.js';
import '../TabNavigation/TabNavigation.js';
import '../TabNavigation/TabNavigationItem.js';
import '../Modal/Modal.js';
import '@livingdesign/tokens/dist/js/light/regular/components/ErrorMessage';
import '../SearchBox/SearchBox.js';
import '../AutoComplete/AutoComplete.js';
import '../TextArea/TextArea.js';
import '../ProgressIndicator/ProgressIndicator.js';
import '../Panel/Panel.js';
import '../Calendar/locale/wmLocale.js';
import '../Calendar/locale/stdLocale.js';
import '../Calendar/context.js';
import 'dayjs';
import '../Calendar/RenderDays.js';
import '../Calendar/RenderWeeks.js';
import '../components/Popover/Popover.js';
import '../components/InfoUnderline/InfoUnderline.js';
import '../CardActionArea/CardActionArea.js';
import '../HierarchySelector/HierarchySelector.js';
import '../Pagination/Pagination.js';
import '../DisplayTag/DisplayTag.js';
import '../PageHeader/PageHeader.js';
import './Table.js';
import { Tooltip } from '../Tooltip/Tooltip.js';
import '../ValueChange/ValueChange.js';
import '../OverlayHeader/OverlayHeader.js';
import styles from './TableHeader.module.scss.js';

var _excluded = ["columnDef"];
var TableHeader = /*#__PURE__*/React__default.memo(function (props) {
  var columnDef = props.columnDef,
    rest = _objectWithoutProperties(props, _excluded);
  return (
    /*#__PURE__*/
    // @ts-ignore: DataTableHeader 'children' prop expects type 'string', we suppress this error for now to avoid copy over many components from living-design, this can be fixed when we start using ag-grid in future.
    React__default.createElement(DataTableHeader, _extends({
      width: columnDef.width,
      key: columnDef === null || columnDef === void 0 ? void 0 : columnDef.columnIndex,
      UNSAFE_className: classNames(styles.text, columnDef !== null && columnDef !== void 0 && columnDef.fixedColumn ? styles.fixedColumnHeader : '', columnDef !== null && columnDef !== void 0 && columnDef.showColumnDivider ? styles.columnDivider : '', columnDef.showHeaderText === false ? styles.invisibleHeader : '')
    }, rest), columnDef.tooltipProps ? /*#__PURE__*/React__default.createElement(Tooltip, columnDef.tooltipProps, /*#__PURE__*/React__default.createElement("span", {
      className: styles.headerText
    }, columnDef.header)) : columnDef.header)
  );
});
TableHeader.displayName = 'TableHeader';

export { TableHeader };
